.bone {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: 4px;
  background: var(--panel-3);

  /* Shown only after 150ms of loading and pulsing opacity 1 to .55 over 1.6s (P13). `backwards` keeps
   the bone invisible through the delay; the text that announces "Loading" is there at once. The
   300ms minimum on screen is `lib/useSkeletonHold.ts`. Reduced motion gets a still bone. */
  animation:
    bone-appear 1ms linear 150ms backwards,
    bone-pulse 1.6s ease-in-out 150ms infinite;
}

@keyframes bone-appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes bone-pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.55;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bone {
    animation: none;
    opacity: 1;
  }
}

.rows {
  display: grid;
  gap: 14px;
  padding: 4px 0;
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.lines {
  display: grid;
  flex: 1;
  gap: 7px;
}

.tile {
  min-height: var(--tile-min);
  padding: 14px 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
}

.tileBody {
  display: grid;
  gap: 10px;
}
